import type { IconData } from '@stacksjs/iconify-core'

export const sj1x1: IconData = {
  "body": "<path fill=\"#ef2b2d\" d=\"M0 0h512v512H0z\"/><path fill=\"#fff\" d=\"M128 0h128v512H128z\"/><path fill=\"#fff\" d=\"M0 192h512v128H0z\"/><path fill=\"#002868\" d=\"M160 0h64v512h-64z\"/><path fill=\"#002868\" d=\"M0 224h512v64H0z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default sj1x1
